// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_gray-light":"#eaeaea","formRow":"account_formRow__ojlUq","inputContainer":"account_inputContainer__3S1WL"};